/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AllowedAction {
    NONE = 'None',
    VOID = 'Void',
    REFUND = 'Refund',
    WAITING = 'Waiting',
}